import { Injectable } from "@angular/core";
import { IID_OL_ESPLETATO_KO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolEspletatoKoStore } from "./espletatoKo.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';



@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ESPLETAMENTO_NEGATIVO)
export class IIDolEspletatoKoQuery extends AbstractInterfaceDataQuery<IID_OL_ESPLETATO_KO> {

  constructor(protected store: IIDolEspletatoKoStore) {
    super(store);
  }
}
